var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "editor overflow-visible" },
    [
      _c("editor-menu-bar", {
        attrs: { editor: _vm.editor },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ commands, isActive }) {
              return [
                _c(
                  "div",
                  { staticClass: "menubar flex items-center space-x-2" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "menubar__button",
                        class: { "is-active": isActive.bold() },
                        attrs: { type: "button" },
                        on: { click: commands.bold },
                      },
                      [
                        _c("span", {
                          staticClass: "icon mdi mdi-format-bold",
                          attrs: { title: "bold" },
                        }),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "menubar__button",
                        class: { "is-active": isActive.italic() },
                        attrs: { type: "button" },
                        on: { click: commands.italic },
                      },
                      [
                        _c("span", {
                          staticClass: "icon mdi mdi-format-italic",
                          attrs: { title: "italic" },
                        }),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "menubar__button",
                        class: { "is-active": isActive.strike() },
                        attrs: { type: "button" },
                        on: { click: commands.strike },
                      },
                      [
                        _c("span", {
                          staticClass:
                            "icon mdi mdi-format-strikethrough-variant",
                          attrs: { title: "strikethrough" },
                        }),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "menubar__button",
                        class: { "is-active": isActive.underline() },
                        attrs: { type: "button" },
                        on: { click: commands.underline },
                      },
                      [
                        _c("span", {
                          staticClass: "icon mdi mdi-format-underline",
                          attrs: { title: "underline" },
                        }),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "menubar__button",
                        class: { "is-active": isActive.bullet_list() },
                        attrs: { type: "button" },
                        on: { click: commands.bullet_list },
                      },
                      [
                        _c("span", {
                          staticClass:
                            "icon mdi mdi-format-list-bulleted-square",
                          attrs: { title: "unordered list" },
                        }),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "menubar__button",
                        class: { "is-active": isActive.ordered_list() },
                        attrs: { type: "button" },
                        on: { click: commands.ordered_list },
                      },
                      [
                        _c("span", {
                          staticClass: "icon mdi mdi-format-list-numbered",
                          attrs: { title: "ordered list" },
                        }),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "menubar__button",
                        class: { "is-active": isActive.blockquote() },
                        attrs: { type: "button" },
                        on: { click: commands.blockquote },
                      },
                      [
                        _c("span", {
                          staticClass: "icon mdi mdi-format-quote-close",
                          attrs: { title: "blockquote" },
                        }),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "menubar__button",
                        attrs: { type: "button" },
                        on: { click: commands.undo },
                      },
                      [
                        _c("span", {
                          staticClass: "icon mdi mdi-undo",
                          attrs: { title: "undo" },
                        }),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "menubar__button",
                        attrs: { type: "button" },
                        on: { click: commands.redo },
                      },
                      [
                        _c("span", {
                          staticClass: "icon mdi mdi-redo",
                          attrs: { title: "redo" },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _c("editor-content", {
        staticClass: "editor__content focus:outline-none",
        attrs: { editor: _vm.editor },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }